import React from "react";
import { Col, Row } from "react-bootstrap";
import CountUp from "react-countup";
import up from "../../../../assets/DigitalMarketing/image/dashboard/arrow_up.svg";
import down from "../../../../assets/DigitalMarketing/image/dashboard/arrow down.svg";
import { BsThreeDots } from "react-icons/bs";
import { validateNumber } from "../Utils/validation";

function CitiesSpotlight(props) {
  const { CountList, filter } = props;
  return (
    <>
      <div className="d-flex justify-content-between align-item-center mt-3">
        <h3 className="f-20 fw-600">
          Insights from the cities in the spotlight 
        </h3>
        {filter}
        {/* <BsThreeDots className="c-blue cursur" /> */}
      </div>
      <Row className="Dashboard">
        {CountList.map((a, i) => {
          return (
            <Col md={6} className="mt-2" key={i}>
              <div className="box-count">
                <div>
                  <div className="dash-detail">
                    <span className="f-16">{a.title}</span>
                    <br></br>
                    <span className="text-bold">
                      {a.title === "No. of Screen Views Per Day" ? (
                        `${
                          validateNumber(a.list)
                            ? a.list || 0
                            : a.list?.toFixed(2) || 0
                        }`
                      ) : (
                        <CountUp end={a.list} duration={3} />
                      )}
                    </span>
                  </div>
                  {/* {true ? (
                    <>
                      <img src={up} width={15} />
                      <small className="c-green"> +0.00.</small>
                    </>
                  ) : (
                    <>
                      <img src={down} />
                      <small className="c-red"> +0.00%.</small>
                    </>
                  )}
                  <small> vs Previous month</small> */}
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </>
  );
}

export default React.memo(CitiesSpotlight);
